import { ContactSection } from "@covertree/layouts/PageLayout/SidebarView/ContactTooltip";

import {
  GENERAL_EMAIL_ADDRESS,
  HELP_EMAIL_ADDRESS,
  CLAIMS_EMAIL_ADDRESS,
  AGENT_HELP_ADDRESS,
} from "@consts/index";
import { SALES_EMAIL_ADDRESS } from "@covertree/consts";
import { UW_EMAIL } from "@covertree/consts";

export function getContactUsSections(
  isInternalAgent: boolean
): ContactSection[] {
  if (isInternalAgent) {
    return [
      {
        name: "Agent Sales",
        email: GENERAL_EMAIL_ADDRESS,
      },
      {
        name: "Agent Service",
        email: HELP_EMAIL_ADDRESS,
      },
      {
        name: "Agent Underwriting",
        email: UW_EMAIL,
      },
      { name: "Claims", email: CLAIMS_EMAIL_ADDRESS },
    ];
  }

  return [
    {
      name: "Pre-issuance",
      email: SALES_EMAIL_ADDRESS,
    },
    {
      name: "Post-issuance",
      email: AGENT_HELP_ADDRESS,
    },
    {
      name: "UW Flags",
      email: UW_EMAIL,
    },
    { name: "Claims", email: CLAIMS_EMAIL_ADDRESS },
  ];
}
